export const SUPPORTED_REGIONS = ["us", "in", "default"];
export const SUPPORTED_WORKFLOWS = ["og", "ng"];

export const CF_REGION_HEADER = "x-cf-region";

export const STARTER_KIT_PRICE = {
  og: 149,
  ng: 169,
};

export const FALLBACK_DISCOUNT_CODES = {
  ng: "INITONG",
  og: "INITO99",
};

export const FALLBACK_DISCOUNT_CODE_PRICE = {
  ng: 50,
  og: 50,
};

// Default discount amounts used in marketing CTAs per workflow
// (e.g. "Get $50 off" → "Get $60/$70 off" when sale is active)
export const SALE_CTA_DISCOUNT_AMOUNT: Record<"og" | "ng", number> = {
  og: 50,
  ng: 80,
};

export const AFFILIATE_DISCOUNT_CODE = "CONFIRM99";

export const QUIZ_VARIANT_CONTROL = "control" as const;
export const QUIZ_VARIANT_TEST_A = "test_a" as const;
export const QUIZ_VARIANT_TEST_B = "test_b" as const;
export type QuizExperimentVariant =
  | typeof QUIZ_VARIANT_CONTROL
  | typeof QUIZ_VARIANT_TEST_A
  | typeof QUIZ_VARIANT_TEST_B;

export const CANONICAL_QUERY_CODES = new Set([
  "dora15",
  "pcosdr15",
  "emilyk89",
  "laurengrace15",
  "tmam15",
  "caty15",
  "kaleigh89",
  "lindsey89",
  "primal15",
  "thebirthhour",
]);

export enum OS {
  ANDROID = "android",
  IOS = "ios",
}

export function shouldCanonicalizeToBaseUrl(searchParams: {
  [key: string]: string | string[] | undefined;
}) {
  const discCode = searchParams.disc_code;
  if (!discCode) return false;
  const value = Array.isArray(discCode) ? discCode[0] : discCode;
  return value ? CANONICAL_QUERY_CODES.has(value.toLowerCase()) : false;
}
